var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUngroupedScreensIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    rx: 3,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4415 4.48047H13.4116V11.5856C13.4116 12.3644 13.2275 13.0494 12.8593 13.6406C12.4947 14.2318 11.9813 14.6938 11.3193 15.0266C10.6573 15.3559 9.88379 15.5205 8.99875 15.5205C8.11017 15.5205 7.33487 15.3559 6.67286 15.0266C6.01085 14.6938 5.49753 14.2318 5.13289 13.6406C4.76826 13.0494 4.58594 12.3644 4.58594 11.5856V4.48047H6.55604V11.421C6.55604 11.8741 6.65516 12.2777 6.85341 12.6317C7.0552 12.9857 7.33841 13.2636 7.70305 13.4654C8.06769 13.6637 8.49959 13.7628 8.99875 13.7628C9.49792 13.7628 9.92981 13.6637 10.2945 13.4654C10.6626 13.2636 10.9458 12.9857 11.1441 12.6317C11.3423 12.2777 11.4415 11.8741 11.4415 11.421V4.48047Z",
    fill: "#2F394B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUngroupedScreensIcon);
export default __webpack_public_path__ + "static/media/ungrouped-screens-icon.8fea11b89d60748a06bd5c865d330b5d.svg";
export { ForwardRef as ReactComponent };